import React from 'react';
import styled from 'styled-components';
import { Card, Section } from '../../../common';
import ProfileCardHeader from '../../../common/ProfileCardHeader';
import { map } from 'ramda';

export default class AboutProject extends React.Component {
  render() {
    const { stories } = this.props;
    return (
      <BackgroundCover>
        <AboutProjectSection>
          {map(story => (
            <ProjectCard key={story.cardTitle}>
              <ProfileCardHeader {...story.profile} />
              <TextWrapper>{map(line => <div key={line}>{line}</div>)(story.lines)}</TextWrapper>
            </ProjectCard>
          ))(stories)}
        </AboutProjectSection>
      </BackgroundCover>
    );
  }
}

const TextWrapper = styled.div`
  line-height: 24px;
  font-size: 14px;

  & > *:not(:last-child) {
    margin-bottom: 16px;
  }
`;

const ProjectCard = styled(Card)`
  padding: 16px;

  & > *:not(:last-child) {
    margin-bottom: 16px;
  }
`;

const AboutProjectSection = styled(Section)`
  padding: 56px 0;
  display: flex;

  & > *:not(:last-child) {
    margin-right: 16px;
  }

  @media screen and (max-width: 768px) {
    flex-wrap: wrap;

    & > *:first-child {
      margin-bottom: 16px;
      margin-right: 0;
    }
  }
`;

const BackgroundCover = styled.div`
  background-color: #f2f5f7;
`;
